import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { RouteChildrenProps } from 'react-router';
import { selectRow, selectRowByRowIndex } from '@client-shared/ui-agGrid';

import Routes from '../../../routes';
import { modalDataSelector } from '../../../shared/modals/modals.selectors';
import { lastClientIdSelector } from '../../../administration/applicationSettings/store/selectors';
import Spinner from '../../../shared/spinner.component';
import Button from '../../../shared/button.component';


import { scenariosSelector } from '../../shared/store/selectors';
import ScenarioManageMembersGrid from './ScenarioManageMembersGrid.component';
import {
  hideDeleteScenarioMemberModal,
} from './store/actions';
import { DeleteModalData } from './types';
import { MODAL_NAMES } from './constants';
import { Scenario, ScenarioMember, useScenarioMetadata } from '@queries/scenarios';

type ScenarioManageMembersProps = {
  clientId: number,
  scenarios: Scenario[],
  selectRow: typeof selectRow,
  selectRowByRowIndex: typeof selectRowByRowIndex,
  deleteScenarioMemberData: DeleteModalData<ScenarioMember>,
  hideDeleteScenarioMemberModal: () => void,
}

const ScenarioManageMembers = ({
  clientId,
  match,
  history,
  deleteScenarioMemberData,
  hideDeleteScenarioMemberModal,
  selectRow,
  selectRowByRowIndex,
}: RouteChildrenProps<{scenarioId: string}> & ScenarioManageMembersProps) => {
  const scenarioId = match!.params!.scenarioId;

  const navigateToScenario = useCallback(() => {
    history.push(Routes.scenarios.MEMBERS_LIST.replace(/:scenarioId/, scenarioId));
  }, [history, scenarioId]);

  const {
    data: scenarioMetadata,
  } = useScenarioMetadata({ scenarioId: Number(scenarioId) });

  return (
    <div className="scenario-add-member-list with-editable-grid">
      <div className="page">
        <div className="container-fluid">
          <div className="row no-gutters py-3 d-flex align-items-center">
            <div className="d-flex flex-row">
              <Button
                onClick={navigateToScenario}
                kind="secondary"
              >
                Back to scenario
              </Button>
              <h5 className="ml-3"> Manage members - { scenarioMetadata ? scenarioMetadata?.scenarioName : <Spinner small className={'spinner-no-margin'}/> }</h5>
            </div>
          </div>
          <div>
            <ScenarioManageMembersGrid
              scenarioId={Number(scenarioId)}
              clientId={clientId}
              selectRow={selectRow}
              selectRowByRowIndex={selectRowByRowIndex}
              deleteModalData={deleteScenarioMemberData}
              hideScenarioMemberModalForDelete={hideDeleteScenarioMemberModal}
              navigateToScenario={navigateToScenario}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  clientId: lastClientIdSelector(state),
  scenarios: scenariosSelector(state),
  deleteScenarioMemberData: modalDataSelector(state, MODAL_NAMES.DeleteScenarioMemberModal),
});

export default connect(mapStateToProps, {
  selectRow,
  selectRowByRowIndex,
  hideDeleteScenarioMemberModal,
})(ScenarioManageMembers);
